import React from 'react'
import { Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import { MdAddBusiness } from 'react-icons/md'
import i18next from 'i18next'

const styles = () => ({
  icon: {
    cursor: 'pointer',
    fontSize: 18,
    '&:hover': {
      opacity: 0.8,
    },
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
})

const AddNewProduct = ({ classes, noFSPanelProps }) => {
  const { showAddProduct, newProductFormOpener } = noFSPanelProps
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <Tooltip title={rtl ? 'اضافة منتج جديد' : 'Add New Product'}>
      <span
        className={classes.iconWrapper}
        style={{ display: showAddProduct ? null : 'none' }}
        onClick={() => newProductFormOpener()}
      >
        <MdAddBusiness className={classes.icon} />
      </span>
    </Tooltip>
  )
}

const WrappedAddNewProduct = withStyles(styles)(AddNewProduct)

export default WrappedAddNewProduct
